module.exports = __webpack_public_path__ + "p2_img2.jpg?9f35cebf1346fcb3a19798df8a82dc7f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p2/p2_img2.jpg
// module id = 101
// module chunks = 0